import { render } from "./ErrorAlert.vue?vue&type=template&id=d2f160ac"
import script from "./ErrorAlert.vue?vue&type=script&lang=js"
export * from "./ErrorAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__